import * as React from "react";
import { CardType } from "../../../../../data";
import { RenderMainHeading, RenderSubheading } from "../../../components";
export class RenderFavorites extends React.Component {
    renderToggleOddsBtn(index) {
        return {
            shouldShow: index === 0 && this.props.state.isMiniEventCard,
            toggled: this.props.state.showOddBtns,
            tooltipMessage: this.props.state.tooltipMessage,
            onClick: this.props.state.toggleOddsBtnOnClick
        };
    }
    render() {
        let renderedSubheadings = 0;
        const headingId = this.props.state.sports[0];
        const config = this.props.state.options.dataProvider.cardConfiguration[headingId]
            || this.props.state.options.dataProvider.cardConfiguration[0];
        const mainHeading = {
            id: headingId,
            name: this.props.name,
            sportId: ""
        };
        return React.createElement(RenderMainHeading, { key: `favorites-section-${mainHeading.id}`, id: `favorite-section-${mainHeading.id}`, name: mainHeading.name, eventsCountLength: this.props.state.displayFavoriteEvents.length, cms: Object.assign(Object.assign({}, this.props.cms), { ShowLivePhraseBeforeSportName: false }), dict: {}, shouldCollapse: false, toggleOddsBtn: this.renderToggleOddsBtn(0), marketNames: [], marketTemplates: [], cardType: CardType.Regular, renderedHeadings: 0 }, this.props.state.displayFavoriteLeagues.map((league) => {
            const events = this.props.state.displayFavoriteEventsByLeague(league.id);
            const chunks = this.props.state.getEventsHeight(events);
            return React.createElement(RenderSubheading, { key: `subheading-${league.id}`, id: league.id, name: league.name, eventsCountLength: events.length, cms: this.props.cms, marketNames: this.props.getMarketNames(Object.assign(Object.assign({}, mainHeading), { sportId: league.sportId })), marketTemplates: [], renderedHeadings: renderedSubheadings++, cardType: config.cardType }, this.props.getEvents(0, events, { id: headingId }, chunks, league));
        }));
    }
}
//# sourceMappingURL=RenderFavorites.js.map